export const environment = {
  name: 'dev',
  production: false,
  azure: true,
  useHashBang: false,
  baseUrl: 'https://dwp-dev.bmwgroup.com',
  oauth2: {
    issuer: 'https://emea.int.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha',
    clientId: '319a5465-bb35-4d6a-914c-bd24ceef6219',
    scope: 'openid profile b2xroles organization email',
    redirectUri: 'https://dwp-dev.bmwgroup.com/portal/eam',
    postLogoutRedirectUri: 'https://dwp-dev.bmwgroup.com/portal/eam/logout',
    showDebugInformation: true,
    options: {
      acr_values: 'strongAuth4000Service',
      realms: 'alpha',
    },
  }
};
